export const PICK_TYPE_STYLES = {
    PALLET: "bg-purple-100 text-purple-800",
    BOX: "bg-blue-100 text-blue-800",
    PIECE: "bg-gray-100 text-gray-800"
}

export const STATUS_STYLES = {
    PENDING: "bg-yellow-100 text-yellow-800",
    ASSIGNED: "bg-blue-100 text-blue-800",
    IN_PROGRESS: "bg-indigo-100 text-indigo-800",
    COMPLETED: "bg-green-100 text-green-800",
    SKIPPED: "bg-gray-100 text-gray-800",
    CANCELED: "bg-red-100 text-red-800"
}
